import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import BImg from "../../Assetes/Images/burgimg.jpg"
import Modal from 'react-bootstrap/Modal';
import MenuBox from './MenuBox';
import AddFavorite from './AddFavorite';
import FlyBtn from './FlyBtn';
import { API_URL, BASE_URL, IMAGE_URL, priceunit } from '../../Components/client-config';
import { toast } from 'react-toastify';
import mergn from 'mergn-webapp-sdk'
import _ from 'lodash';
import { connect, useSelector } from 'react-redux';
import { saveCart } from '../../Redux';
import { favouriteAdd } from '../../Redux/actions/customer';
import CardImgSkelton from '../../Assetes/SkeletonLoader/CardImgSkelton';
import SelectStoreModal from '../../Components/selectStoreModal';
import JazzCashOnly from '../../Components/JazzCashOnly';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { COUNTRY_NAME } from '../../lib';
import { itemReady } from '../../utils/productValidations';
var CryptoJS = require("crypto-js");

function ManuCard(props: any) {
  const itemData = useSelector((state: any) => state.menu.itemData);
  let cartData = useSelector((state: any) => state.cart.cartData)
  const storeSelected = useSelector((state: any) => state.store.storeSelected);
  const [value, setValue] = useState(0);
  const isLogged = useSelector((state: any) => state.customer.isLogged);
  const orderType = useSelector((state: any) => state.payment.orderType);
  const [fav, setFav] = useState(false);
  const [disable, setDisable] = useState(false);
  const [selectStoreShow, setSelectStoreModal] = useState(false);
  const handleSelectStoreClose = () => setSelectStoreModal(false);
  const [selectJCShow, setSelectJCModal] = useState(false);
  const [altText, setAltText] = useState("");
  const { t } = useTranslation();
  function addtoCartItem(item: any) {
    let selectedSize = item.item_size[0];
    let initialPrice = Math.round(((selectedSize.discount_price || selectedSize.discount_price == 0) && (selectedSize.order_channel == 'online')) ? Math.round(selectedSize.discount_price) : Math.round(selectedSize.mrp));
    let itemPrice = Math.round((selectedSize.discount_price || selectedSize.discount_price == 0) && (selectedSize.order_channel == 'online')) ? Math.round(selectedSize.discount_price) : Math.round(selectedSize.mrp)
    let discounted_item: any = false;
    let cart: any = cartData;
    if ((item.item_size[0].discount_price || item.item_size[0].discount_price == 0) && (item.item_size[0].order_channel == "all" || item.item_size[0].order_channel == "online")) {
      discounted_item = true;
    } else {
      discounted_item = false;
    }

    if (!_.isEmpty(cart)) {
      let found = false;

      cart.forEach((element: any) => {
        if (element["item"]) {
          if (element["item"].menu_item_id == item.menu_item_id) {
            if (item.item_size[0].size == element.selectedsize.size) {
              element.quantity = element.quantity + 1;
              let itemNetPrice = ((item.item_size[0].discount_price || item.item_size[0].discount_price == 0) && item.item_size[0].order_channel == 'online') ? Math.round(item.item_size[0].discount_price) : Math.round(item.item_size[0].mrp)
              element.totalItemPrice = itemNetPrice + element.totalItemPrice;
              found = true
            }
          }
        }
      });
      if (!found) {
        const itemcart = {
          item: item,
          quantity: 1,
          selectedsize: selectedSize,
          price: Math.round(initialPrice),
          totalItemPrice: Math.round(itemPrice),
          modifiers: item.modifiers,
          collapseIn: false
        };
        cart.push(itemcart);
      }
    } else {
      const itemcart = {
        item: item,
        quantity: 1,
        selectedsize: selectedSize,
        price: Math.round(initialPrice),
        totalItemPrice: Math.round(itemPrice),
        modifiers: item.modifiers,
        collapseIn: false
      };
      cart.push(itemcart);
    }

    props.saveCart(cart);
    let products: any = []
    let MapObj: any = {}
    MapObj = {
      item: item,
      quantity: 1,
      selectedsize: selectedSize,
      price: Math.round(initialPrice),
      totalItemPrice: Math.round(itemPrice),
      variant: selectedSize.size
    }
    products.push(MapObj)
    let windowObj = (window as any)
    windowObj.dataLayer.push({ ecommerce: null });
    windowObj.dataLayer.push({
      'event': 'add_to_cart',
      'ecommerce': {
        currency: 'PKR',
        value: Math.round(itemPrice),
        items: [
          {
            item_id: item.menu_item_id ? item.menu_item_id : item.combo_id,
            item_name: item.item_name ? item.item_name : item.combo_name,
            price: Math.round(itemPrice),
            quantity: 1,
            item_category: item?.item_group_id?.group_name ? item.item_group_id.group_name : item.group_id.group_name,
            discount: discounted_item ? item.discount_value : 0
          }
        ]
      }
    });
    if (storeSelected) {
      props.setHeaderUpdate(props.headerUpdate + 1)
      toast.success(`${item.item_name} ${t("ADDED_TO_CART")}`, {
        position: toast.POSITION.TOP_RIGHT,
        hideProgressBar: true,
        autoClose: 3000
      });
      if (!_.isEmpty(storeSelected) && props.setShowSuggProductOutSide) {
        if (item.child_products && item.child_products.length > 0) {
          item.child_products.forEach((obj: any) => {
            if (obj.is_lsm == 1 && obj.is_active == 1) {
              return storeSelected && obj.itemStores.length > 0 && obj.itemStores.map((obj2: any) => {
                if ((obj2.store_id.store_id == storeSelected.store_id) && obj.is_active == 1) {         
                  setTimeout(() => {
                    props.setShowSuggProductOutSide(true)
                  }, 500)
                }
              })
            } else if (obj.is_lsm == 0 && obj.is_active == 1) {   
              setTimeout(() => {
                props.setShowSuggProductOutSide(true)
              }, 500)
            } else if (obj.is_lsm === 2 && obj.is_active == 1) {
              let exist = false;
              let timeoutSet = false;

              obj.itemStores.forEach((obj2: any) => {
                if (obj2.store_id.store_id == storeSelected.store_id && obj.is_active === 1) {
                  exist = true;
                }
              });
              if (!exist && !timeoutSet) {  
                setTimeout(() => {
                  props.setShowSuggProductOutSide(true);
                }, 500);
                timeoutSet = true;
              }
              return null;
            }
          })
        }
      }
    }

  }
  function addtoCartCombo(item: any) {
    let initialPrice = Math.round(((item.discount_price || item.discount_price == 0) && (item.order_channel == 'online')) ? Math.round(item.discount_price) : Math.round(item.combo_mrp_price));
    let itemPrice = Math.round((item.discount_price || item.discount_price == 0) && (item.order_channel == 'online')) ? Math.round(item.discount_price) : Math.round(item.combo_mrp_price)
    let discounted_item: any = false;
    let cart: any = cartData;
    if ((item.discount_price || item.discount_price == 0) && (item.order_channel == "all" || item.order_channel == "online")) {
      discounted_item = true;
    } else {
      discounted_item = false;
    }

    if (!_.isEmpty(cart)) {
      let found = false;
      cart.forEach((element: any) => {
        if (element["combo"]) {
          if (element["combo"].combo_id == item.combo_id) {
            element.quantity = element.quantity + 1;
            let itemNetPrice = ((item.discount_price || item.discount_price == 0) && item.order_channel == 'online') ? Math.round(item.discount_price) : Math.round(item.combo_mrp_price)
            element.totalItemPrice = itemNetPrice + element.totalItemPrice;
            found = true
          }
        }
      });
      if (!found) {
        const itemcart = {
          combo: item,
          quantity: 1,
          price: Math.round(initialPrice),
          totalItemPrice: Math.round(itemPrice),
          modifiers: item.modifiers,
          collapseIn: false
        };
        cart.push(itemcart);
      }
    } else {
      const itemcart = {
        combo: item,
        quantity: 1,
        price: Math.round(initialPrice),
        totalItemPrice: Math.round(itemPrice),
        modifiers: item.modifiers,
        collapseIn: false
      };
      cart.push(itemcart);
    }
    props.saveCart(cart);
    let products: any = []
    let MapObj: any = {}
    MapObj = {
      combo: item,
      quantity: 1,
      price: Math.round(initialPrice),
      totalItemPrice: Math.round(itemPrice)
    }
    products.push(MapObj)
    let windowObj = (window as any)
    windowObj.dataLayer.push({ ecommerce: null });
    windowObj.dataLayer.push({
      'event': 'add_to_cart',
      'ecommerce': {
        currency: 'PKR',
        value: Math.round(itemPrice),
        items: [
          {
            item_id: item.menu_item_id ? item.menu_item_id : item.combo_id,
            item_name: item.item_name ? item.item_name : item.combo_name,
            price: Math.round(itemPrice),
            quantity: 1,
            item_category: item?.item_group_id?.group_name ? item.item_group_id.group_name : item.group_id.group_name,
            discount: discounted_item ? item.discount_value : 0
          }
        ]
      }
    });
    if (storeSelected) {
      props.setHeaderUpdate(props.headerUpdate + 1)
      toast.success(`${item.combo_name} ${t("ADDED_TO_CART")}`, {
        position: toast.POSITION.TOP_RIGHT,
        hideProgressBar: true,
        autoClose: 3000
      });
      if (!_.isEmpty(storeSelected) && props.setShowSuggProductOutSide) {
        if (item.child_products && item.child_products.length > 0) {
          item.child_products.forEach((obj: any) => {
            if (obj.is_lsm == 1 && obj.is_active == 1) {
              return storeSelected && obj.itemStores.length > 0 && obj.itemStores.map((obj2: any) => {
                if ((obj2.store_id.store_id == storeSelected.store_id) && obj.is_active == 1) {
                  setTimeout(() => {
                    props.setShowSuggProductOutSide(true)
                  }, 500)
                }
              })
            } else if (obj.is_lsm == 0 && obj.is_active == 1) {
              setTimeout(() => {
                props.setShowSuggProductOutSide(true)
              }, 500)
            } else if (obj.is_lsm === 2 && obj.is_active == 1) {
              let exist = false;
              let timeoutSet = false;

              obj.itemStores.forEach((obj2: any) => {
                if (obj2.store_id.store_id == storeSelected.store_id && obj.is_active === 1) {
                  exist = true;
                }
              });
              if (!exist && !timeoutSet) {
                setTimeout(() => {
                  props.setShowSuggProductOutSide(true);
                }, 500);
                timeoutSet = true;
              }
              return null;
            }
          })
        }
      }
    }

  }
  function handleAdd(item: any) {
    let channel = orderType;
    let obj: any = {
      mode: 'online'
    }
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(obj), process.env.REACT_APP_EncryptionKey).toString();
    if (_.isEmpty(storeSelected)) {
      setSelectStoreModal(true)
    }
    if (disable) return;
    if (item.menu_item_id > 0) {
      props.setNormalDealData(null)
      props.setNormalItemData(item)
      axios.post(`${API_URL}menu/item/${item.menu_item_id}`, { body: encryptedData }).then((response: any) => {
        if (response.data.success) {
          let itemData = response.data.successResponse;
          if (channel) {
            if (channel == "Delivery") {
              if (itemData.item_channel_id == 1 || itemData.item_channel_id == 5) {
                addtoCartItem(item)
              } else {
                toast.info(t("PRODUCT_ONLY_PICKUP"), {
                  position: toast.POSITION.TOP_RIGHT,
                  hideProgressBar: true,
                  autoClose: 3000,
                });
              }
            } else if (channel == "Pickup") {
              if (itemData.item_channel_id == 2 || itemData.item_channel_id == 5) {
                addtoCartItem(item)
              } else {
                toast.info(t("ONLY_DELIVERY_AVAILABLE"), {
                  position: toast.POSITION.TOP_RIGHT,
                  hideProgressBar: true,
                  autoClose: 3000,
                });
              }
            }
          } else {
            if (itemData.item_channel_id == 5) {
              addtoCartItem(item)
            } else {
              toast.info(t("PRODUCT_NOT_AVAILABLE"), {
                position: toast.POSITION.TOP_RIGHT,
                hideProgressBar: true,
                autoClose: 3000,
              });
            }
          }
        }
      }).catch(err => {
        toast.info(t("PRODUCT_NOT_AVAILABLE"), {
          position: toast.POSITION.TOP_RIGHT,
          hideProgressBar: true,
          autoClose: 3000,
        });
      })
    } else {
      props.setNormalItemData(null)
      props.setNormalDealData(item)
      axios.post(`${API_URL}menu/combo/${item.combo_id}`, { body: encryptedData }).then((response: any) => {
        if (response.data.success) {
          let comboData = response.data.successResponse;
          if (channel) {
            if (channel == "Delivery") {
              if (comboData.combo_channel_id == 1 || comboData.combo_channel_id == 5) {
                addtoCartCombo(item)
              } else {
                toast.info(t("PRODUCT_ONLY_PICKUP"), {
                  position: toast.POSITION.TOP_RIGHT,
                  hideProgressBar: true,
                  autoClose: 3000,
                });
              }
            } else if (channel == "Pickup") {
              if (comboData.combo_channel_id == 2 || comboData.combo_channel_id == 5) {
                addtoCartCombo(item)
              } else {
                toast.info(t("ONLY_DELIVERY_AVAILABLE"), {
                  position: toast.POSITION.TOP_RIGHT,
                  hideProgressBar: true,
                  autoClose: 3000,
                });
              }
            }
          } else {
            if (comboData.combo_channel_id == 5) {
              addtoCartCombo(item)
            } else {
              toast.info(t("PRODUCT_NOT_AVAILABLE"), {
                position: toast.POSITION.TOP_RIGHT,
                hideProgressBar: true,
                autoClose: 3000,
              });
            }
          }
        }
      }).catch(err => {
        toast.info(t("PRODUCT_NOT_AVAILABLE"), {
          position: toast.POSITION.TOP_RIGHT,
          hideProgressBar: true,
          autoClose: 3000,
        });
      })

    }
  };

  const handleSelectJSToogle = () => {
    if ((props.product.item_size && props.product.item_size[0].is_jazz_cash === 1) || (props.product.is_jazz_cash && props.product.is_jazz_cash === 1)) {
      setSelectJCModal((prev) => {
        return !prev
      })
    }
  }

  const handleFavourite = (alreadyFav: any, id: any, type: any, product_name: any) => {

    if (!isLogged) {
      toast.error(t("SIGNIN_TO_FAVORITE"))
      return;
    }
    if (alreadyFav || fav) return;
    let data: any = {};
    let windowObj = (window as any)
    windowObj.dataLayer.push({ ecommerce: null });
    data.product = product_name;
    if (type == "combo") {
      data.combo_id = id
      props.favouriteAdd(data, setFav)
      windowObj.dataLayer.push({
        'event': 'add_to_wishlist',
        'ecommerce': {
          currency: 'PKR',
          items: [
            {
              item_id: id,
              item_name: product_name,
              price: props.product.combo_mrp_price,
            }
          ]
        }
      });
    }
    else {
      data.menu_item_id = id
      props.favouriteAdd(data, setFav)
      windowObj.dataLayer.push({
        'event': 'add_to_wishlist',
        'ecommerce': {
          currency: 'PKR',
          items: [
            {
              item_id: id,
              item_name: product_name,
              price: props.product.item_size[0].mrp,
            }
          ]
        }
      });
    }
  }

  useEffect(() => {
    if (!props?.product?.is_publish || props?.product?.is_snooze || props?.product?.item_close_flag) {
      setDisable(true);
    }
  }, [])

  useEffect(() => {
    if (props.product.menu_item_id) {
      setAltText(props.product?.item_size[0].alt_text);
    }
    else {
      setAltText(props.product?.alt_text);
    }
  }, [])

  const handleEvent = (product: any) => {

    const makeItem = {
      name: product.combo_name ? product.combo_name : product.item_name,
      price: product.combo_name ? product.combo_mrp_price : product.item_size[0].mrp,
      category: product?.item_group_id ? product?.item_group_id?.group_name : product.group_id?.group_name,
      url : {
          page: `${BASE_URL}menu#${product.combo_id ? 'combo' : 'item'}/${product.combo_name ? product.combo_name.replace(/\s+/g, '') :  product.item_name.replace(/\s+/g, '')}_${product.combo_id ? product.combo_id : product.menu_item_id }`,
          product: `${IMAGE_URL}${product.combo_name ? product.image_url : product.item_size[0].image_url}`
      }
    }

    mergn.recordEvent("Product Click", [
      { eventProperty: 'product-name', value: makeItem.name },
      { eventProperty: 'product-price', value: makeItem.price },
      { eventProperty: 'category-name', value: makeItem.category },
      { eventProperty: 'product-page-url', value: makeItem.url.page },
      { eventProperty: 'product-image-url', value: makeItem.url.product }
    ])

  }

  const description =
  props.product.item_size
    ? props.product.item_size[0]?.description || `KFC ${COUNTRY_NAME}`
    : props.product.combo_id > 0
      ? props.product.combo_description || `KFC ${COUNTRY_NAME}`
      : "";


  return (
    <div>

      <div className={`card menu-card ${disable ? "disableShadow" : ""}`}>
        <a href={`#${props.product.combo_id > 0 ? 'combo' : 'item'}/${props.product.combo_id > 0 ? props.product.combo_name.replace(/\s+/g, '') : props.product.item_name.replace(/\s+/g, '')}_${props.product.combo_id > 0 ? props.product.combo_id : props.product.menu_item_id}`} onClick={() => {
          props.selectedItem(props.product)
          handleEvent(props.product)
        }} className='manu-img-item'>
          {props.product.item_size && props.product.item_size[0].image_url ?
            <img className="card-img-top card-img" src={`${IMAGE_URL}${props.product.item_size[0].image_url}`} alt={altText} /> :
            <img className="card-img-top card-img" src={`${IMAGE_URL}${props.product.image_url}`} alt={altText} />
          }
          {
            props.product.ItemTags && props.product.ItemTags.length > 0 &&
            <div className="tag-overlay d-flex gap-2">
              {
                props.product.ItemTags.map((tag: any, index: any) => {
                  return (
                    <img key={index} style={{ backgroundColor: `${tag.tag_id.color}` }} className="tag-icon" src={`${IMAGE_URL}${tag.tag_id.tag_icon}`} alt={tag.tag_id.tag_name} />
                  )
                })
              }
            </div>
          }
          {
            props.product.ComboTags && props.product.ComboTags.length > 0 &&
            <div className="tag-overlay d-flex gap-2">
              {
                props.product.ComboTags.map((tag: any, index: any) => {
                  return (
                    <img key={index} style={{ backgroundColor: `${tag.tag_id.color}` }} className="tag-icon" src={`${IMAGE_URL}${tag.tag_id.tag_icon}`} alt={tag.tag_id.tag_name} />
                  )
                })
              }
            </div>
          }
        </a>
        <div className="card-body p-0">
          <div className='d-flex justify-content-between align-items-center'>
            <h5 className="card-title">{props.product.combo_id > 0 ? props.product.combo_name : props.product.item_name}</h5>
            {/* <AddFavorite /> */}
            <span onClick={() => handleFavourite(props.product.isFav, props.product.combo_id > 0 ? props.product.combo_id : props.product.menu_item_id, props.product.combo_id > 0 ? "combo" : 'item', props.product.combo_id > 0 ? props.product.combo_name : props.product.item_name)} >
              <div>
                {!fav ?
                  <button className='btn-item' > {!props.product.isFav ? <i className="ri-heart-line"></i> : <i className="ri-heart-fill clr-red"></i>}</button> :
                  <button className='btn-item' > <i className="ri-heart-fill clr-red"></i></button>
                }
              </div>
            </span>
            {
              props.product.item_size && props.product.item_size[0].is_jazz_cash === 1 ?
                <img src="/JClogo.png" className="jazzcashlogo" />
                :
                null
            }
            {
              props.product.is_jazz_cash && props.product.is_jazz_cash === 1 ?
                <img src="/JClogo.png" className="jazzcashlogo" />
                :
                null
            }
          </div>
          <p className="card-text" title={description}>
            {description}
          </p>
          {
            (props.product.item_size && props.product.item_size[0].discount_price && props.product.item_size[0].order_channel == "online") &&
            (
              (props.product.item_size[0].discount_price == props.product.item_size[0].mrp) ?
                <h4 className='kfc-price'>
                  <span className='original-value'>
                    {
                      props.product.item_size && ` ${priceunit} ${props.product.item_size[0].discount_price}`
                    }
                  </span>
                </h4>
                :
                <h4 className='kfc-price'>
                  <span style={{ textDecoration: props.product.item_size && (props.product.item_size[0].discount_price || props.product.item_size[0].discount_price == 0) ? 'line-through' : 'none', color: '#d60000' }} className="p-1">
                    {
                      props.product.item_size && priceunit + props.product.item_size[0].mrp
                    }
                    {" "}
                  </span>
                  <span className='original-value'>
                    {
                      props.product.item_size && ` ${priceunit} ${props.product.item_size[0].discount_price}`
                    }
                  </span>
                </h4>
            )
          }
          {
            (props.product && props.product.discount_price && props.product.order_channel == "online") &&
            (
              (props.product.discount_price == props.product.combo_mrp_price) ?
                <h4 className='kfc-price'>
                  <span className='original-value'>
                    {
                      props.product.discount_price && ` ${priceunit} ${props.product.discount_price}`
                    }
                  </span>
                </h4>
                :
                <h4 className='kfc-price'>
                  <span style={{ textDecoration: props.product && (props.product.discount_price || props.product.discount_price == 0) ? 'line-through' : 'none', color: '#d60000' }} className="p-1">
                    {
                      props.product.combo_mrp_price && priceunit + props.product.combo_mrp_price
                    }
                    {" "}
                  </span>
                  <span className='original-value'>
                    {
                      props.product.discount_price && ` ${priceunit} ${props.product.discount_price}`
                    }
                  </span>
                </h4>
            )
          }
          {
            props.product.item_size && props.product.item_size[0].discount_price == null &&
            <h4 className='kfc-price'>
              {props.product.item_size && priceunit + props.product.item_size[0].mrp}{" "}
            </h4>
          }
          {
            props.product.discount_price == null && props.product.item_size == null &&
            <h4 className='kfc-price'>
              {priceunit + props.product.combo_mrp_price}
            </h4>
          }
          <div className='price-label'>
            {!disable && <FlyBtn itemReady={itemReady} selectedItem={props.selectedItem} product={props.product} handleAdd={handleAdd} handleToogle={handleSelectJSToogle} />}
          </div>
        </div>
      </div>
      <SelectStoreModal show={selectStoreShow} handleClose={handleSelectStoreClose} />
      <JazzCashOnly show={selectJCShow} handleToogle={handleSelectJSToogle} />
    </div>
  )
}
const mapDispatchToProps = (dispatch: any) => {
  return {
    saveCart: function (cart: any[]) {
      dispatch(saveCart(cart));
    },
    favouriteAdd: function (data: any, setState?: any) {
      dispatch(favouriteAdd(data, setState));
    }
  };
};

export default connect(null, mapDispatchToProps)(ManuCard);